import { DisposalSet, onReadyEach, select, selectAll } from '@neptune/cx/utils';
import {
    addToMultiParamMap,
    removeFromMultiParamMap,
    toMultiParamMap,
    toURLSearchParams,
    updateResults, valuesFromMultiParamMap
} from '../../fragments/layouts/ay-search-layout/facets';
import { CheckboxTree, CheckboxTreeNode } from './CheckboxTree';
import './styles.scss';

const gc = new DisposalSet();


const getParentCheckboxes = (checkboxEl: HTMLInputElement, rootEl: HTMLDivElement): HTMLInputElement[] => {
    const parentCheckboxes: HTMLInputElement[] = [];
    let currentEl: HTMLElement | null = checkboxEl;
    while (currentEl && currentEl.parentElement && !currentEl.parentElement.contains(rootEl)) {
        currentEl = currentEl.parentElement.closest<HTMLInputElement>(
            '.ay-category-tree-facet__item input[type="checkbox"]'
        );
        if (currentEl) {
            parentCheckboxes.push(currentEl as HTMLInputElement);
        }
    }
    return parentCheckboxes;
}

const initCategoryTreeFacet = (facetEl: HTMLDivElement, pageParam: string) => {
    const parentFormEl = facetEl.parentElement! as HTMLFormElement;
    const searchLayoutEl = facetEl.closest<HTMLDivElement>('.ay-search-layout');
    if (!parentFormEl || !searchLayoutEl) return;

    const facetParamName = select<HTMLInputElement>(parentFormEl, 'input.facet-parameter-name');
    const treeItemCheckboxEls = selectAll<HTMLInputElement>(facetEl, '.ay-category-tree-facet__item input[type="checkbox"]');

    const vocabListEls = selectAll<HTMLUListElement>(facetEl, '.ay-category-tree-facet__list--depth-0');
    for (const listEl of vocabListEls) {
        const tree = new CheckboxTree(listEl);
        console.log(tree);
    }

    const checkboxValues = new Set<string>();
    const valueToCheckboxElMap = new Map<string, HTMLInputElement>();
    for (const checkboxEl of treeItemCheckboxEls) {
        const value = checkboxEl.value;
        checkboxValues.add(value);
        valueToCheckboxElMap.set(value, checkboxEl);
        (gc.register(checkboxEl)
            .addListener('change', (e) => {
                const multiParamMap = toMultiParamMap(new URLSearchParams(window.location.search));
                const value = checkboxEl.value;

                const node = CheckboxTreeNode.getInstance(checkboxEl);

                if (checkboxEl.checked || checkboxEl.indeterminate) {
                    addToMultiParamMap(multiParamMap, facetParamName.value, node ? node.valuesFlat : value);
                } else {
                    removeFromMultiParamMap(multiParamMap, facetParamName.value, node ? node.valuesFlat : value);
                }
                removeFromMultiParamMap(multiParamMap, pageParam, null);

                const nextSelections = valuesFromMultiParamMap(multiParamMap, facetParamName.value);

                for (const otherCheckboxValueEl of checkboxValues) {
                    const otherCheckboxEl = valueToCheckboxElMap.get(otherCheckboxValueEl);
                    if (otherCheckboxEl) {
                        otherCheckboxEl.checked = nextSelections.has(otherCheckboxValueEl);
                    }
                }

                const params = toURLSearchParams(multiParamMap);
                const nextUrl = `${window.location.pathname}?${params}`;
                updateResults(searchLayoutEl, nextUrl, pageParam);
            })
        );
    }
};

export const reinit = (parentEl: HTMLDivElement, replacements: HTMLDivElement[], pageParam: string) => {
    gc.disposeAll();
    const facetEls = selectAll<HTMLDivElement>(parentEl, '.ay-category-tree-facet');

    for (let i = 0; i < facetEls.length; i++) {
        const facetEl = facetEls[i];
        const replacementFacetEl = replacements[i];
        const existingListEls = selectAll<HTMLInputElement>(
            facetEl, '.ay-category-tree-facet__list--depth-0'
        );
        const replacementListEls = selectAll<HTMLInputElement>(
            replacementFacetEl, '.ay-category-tree-facet__list--depth-0'
        );

        for (let k = 0; k < existingListEls.length; k++) {
            const existingListEl = existingListEls[k];
            const replacementListEl = replacementListEls[k];
            if (existingListEl && replacementListEl) {
                existingListEl.parentElement!.replaceChild(replacementListEl, existingListEl);
            }
        }

        initCategoryTreeFacet(facetEl, pageParam);
    }
}

onReadyEach<HTMLDivElement>('.ay-category-tree-facet', facetEl => {
    initCategoryTreeFacet(facetEl, facetEl.dataset.pageParam || 'start')
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}